export default __webpack_public_path__ + "static/media/form.580e8df7.png";